<template>
    <div class="table-responsive">
      <table class="table table-bordered c-table c-table-color">
        <thead>
        <tr class="sticky-header">
          <th>رشد فروش</th>
          <th class="ltr">{{ salesGrowth }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>رشد تولید و ارتقاء بهره‌وری</td>
          <td class="ltr">{{ productivityGrowth }}</td>
        </tr>
        <tr>
          <td>بهبود قیمت‌ها</td>
          <td class="ltr">{{ improvingPrices }}</td>
        </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
export default {
  props: {
    salesGrowth: {
      type: String,
      required: true
    },
    productivityGrowth: {
      type: String,
      required: true
    },
    improvingPrices: {
      type: String,
      required: true
    },
  }
}
</script>

<style scoped>
.table-responsive  {
  border: 1px solid #ccc;
  width: 40%;
  margin: 0 auto;
}

.ltr {
  direction: ltr;
}
</style>
